// Placeholder Redux slice for itineraries
import { createSlice } from '@reduxjs/toolkit';
const itinerarySlice = createSlice({
  name: 'itinerary',
  initialState: {},
  reducers: {}
});
export default itinerarySlice.reducer;
